<template>
  <section class="flex flex-col gap-3 mb-7 w-full sm:w-1/2 md:w-2/5 lg:w-1/3 self-center">
    <h2 class="md:mb-4 checkup-h2">
      Mein Vermögen
    </h2>
    <div class="flex flex-col gap-5">
      <!-- TODO: remove handleMoneyValue, when backend accepts value as float -->
      <ElFormItem
        label="Zum Sparen frei verfügbares Einkommen pro Monat"
        for="monatlichFreiesEinkommen"
        :error="formErrors.monatlichFreiesEinkommen?.[0]"
        label-position="top"
      >
        <MoneyInput
          id="monatlichFreiesEinkommen"
          :model-value="form.monatlichFreiesEinkommen"
          @update:model-value="set('monatlichFreiesEinkommen', handleMoneyValue($event))"
        />
      </ElFormItem>
      <ElFormItem
        label="Gesamtsumme des Vermögens"
        for="vermoegen"
        :error="formErrors.vermoegen?.[0]"
        label-position="top"
      >
        <MoneyInput
          id="vermoegen"
          :model-value="form.vermoegen"
          @update:model-value="set('vermoegen', handleMoneyValue($event))"
        />
      </ElFormItem>
    </div>

    <h2 class="mt-7 mb-2 checkup-h2">
      Meine Verbindlichkeiten
    </h2>

    <div class="flex flex-col gap-5 mb-5">
      <!-- TODO: remove handleMoneyValue, when backend accepts value as float -->
      <ElFormItem
        label="Höhe der monatlichen Verbindlichkeiten"
        for="monatlicheVerbindlichkeiten"
        :error="formErrors.monatlicheVerbindlichkeiten?.[0]"
        label-position="top"
      >
        <MoneyInput
          id="monatlicheVerbindlichkeiten"
          :model-value="form.monatlicheVerbindlichkeiten"
          @update:model-value="set('monatlicheVerbindlichkeiten', handleMoneyValue($event))"
        />
      </ElFormItem>
      <ElFormItem
        label="Gesamtsumme der Verbindlichkeiten"
        for="verbindlichkeiten"
        :error="formErrors.verbindlichkeiten?.[0]"
        label-position="top"
      >
        <MoneyInput
          id="verbindlichkeiten"
          :model-value="form.verbindlichkeiten"
          @update:model-value="set('verbindlichkeiten', handleMoneyValue($event))"
        />
      </ElFormItem>
    </div>

    <ElFormItem
      label="Bemerkung"
      for="bemerkung"
      :error="formErrors.bemerkung?.[0]"
      label-position="top"
    >
      <ElInput
        id="bemerkung"
        v-model="form.bemerkung"
        type="textarea"
        :placeholder="`Bitte ${duzen('gebe hier deine', 'geben Sie Ihre')} Bemerkung ein.`"
        :rows="5"
      />
    </ElFormItem>
  </section>
</template>

<script setup lang="ts">
import { ElFormItem, ElInput } from 'element-plus';

import MoneyInput from '@/application/components/form-elements/MoneyInput/MoneyInput.vue';
import { useStep } from '@/checkup/state';
import { Step } from '@/checkup/utils/steps';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const { form, formErrors, set } = useStep(Step.FINANZEN);
const { duzen } = useBaseDataStore();

// TODO: remove when backend accepts value as float
const handleMoneyValue = (value: number | string | null): number | string | null => {
  if (value === null || value === '') return null;
  if (typeof value === 'number') return value.toString();
  return value;
};
</script>
